// extracted by mini-css-extract-plugin
export default {"wrapper":"SQ","content":"TQ","firstSection":"UQ","text":"VQ","table":"WQ","tableText":"XQ","row":"YQ","column_2":"ZQ","column_1":"aR","column_3":"bR"};
    if(module.hot) {
      // 1726593107024
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  